export default "__VITE_ASSET__CVXypOqR__"